import * as React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { NavProvider } from "./src/contexts/navContext";

// Import your extended theme from a location in `./src`
import customTheme from "./src/theme";

export const wrapRootElement = ({ element }) => (
  // Or ChakraBaseProvider if you only want to compile the default Chakra theme tokens
  <ChakraProvider theme={customTheme}>
    <NavProvider>{element}</NavProvider>
  </ChakraProvider>
);
